<template>
  <section class="inav icase cclearfix">
    <div class="headx">
      <h2>
        <em>
          <b>师资</b>力量
        </em>
      </h2>
      <a href="/team" class="mo">MORE+</a>
    </div>
    <div class="gridlist" id="honor">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <swiper-container
            :slides-per-view="1"

            :autoplay-disable-on-interaction="false"
            loop="true"
            class="swiper-slide"
          >
            <swiper-slide v-for="(teacher, index) in teachers" :key="index">
              <a :href="'/team_in?id=' + teacher.id" :title="teacher.title" class="img">
                <img :src="http + teacher.attachfile" :alt="teacher.title" :title="teacher.title" />
                <div class="cover"></div>
              </a>
              <div class="wd">
                <span>
                  <a :href="'/team_in?id=' + teacher.id" :title="teacher.title">{{ teacher.title }}</a>
                </span>
                <div class="descrption s"></div>
              </div>
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/effect-fade";
import method from "@/utils/Untitl.js";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      http: process.env.VUE_APP_BASE_API,
      teachers: [],
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   const mySwiper = new Swiper(".swiper-container", {
    //     loop: true,
    //     autoplay: {
    //       delay: 3000,
    //       disableOnInteraction: false, // 设置为 false，手动滑动后仍自动轮播
    //     },
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true,
    //     },
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //   });
    // });
    this.getTeachers();
  },
  methods: {
    async getTeachers() {
      const res = await method.index();
      if (res.code == 1) {
        this.teachers = res.data.teachers;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/move/index_Teachers_in.scss";
/* 可添加 Swiper 相关样式 */
</style>